<template>
    <ul class="pagination">
        <li v-if="pagination.current_page <= 1" class="disabled"><span>&laquo;</span></li>
        <li v-if="pagination.current_page > 1">
            <a rel="prev" href="#" aria-label="Anterior" v-on:click.prevent="changePage(pagination.current_page - 1)">
                &laquo;
            </a>
        </li>

        <li v-for="page in pagesNumber" v-bind:key="page" :class="{'active': page == pagination.current_page}">
            <span v-if="page == pagination.current_page">{{ page }}</span>
            <a href="#" v-if="page != pagination.current_page" v-on:click.prevent="changePage(page)">{{ page }}</a>
        </li>

        <li v-if="pagination.current_page < pagination.last_page">
            <a href="#" aria-label="Próxima" v-on:click.prevent="changePage(pagination.current_page + 1)">
                &raquo;
            </a>
        </li>

        <li v-if="pagination.current_page >= pagination.last_page" class="disabled"><span>&raquo;</span></li>
    </ul>
</template>

<script>
    let urlParams = require('../mixins/url-params.js');
    export default {
        mixins: [urlParams],
        data: function () {
            return {
                searchParams: {
                    page: null,
                }
            }
        },
        props: {
            pagination: {
                required: true
            },
            offset: {
                type: Number,
                default: 4
            },
            reload: {
                type: Boolean,
                default: true,
            }
        },
        computed: {
            pagesNumber: function () {
                if (!this.pagination.to) {
                    return [];
                }
                var from = this.pagination.current_page - this.offset;
                if (from < 1) {
                    from = 1;
                }
                var to = from + (this.offset * 2);
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }
                var pagesArray = [];
                for (var i = from; i <= to; i++) {
                    pagesArray.push(i);
                }
                return pagesArray;
            }
        },
        methods: {
            changePage: function (page) {
                this.pagination.current_page = page;
                this.searchParams.page = page;
                var query = this.getUrlQuery(this.searchParams);
                if (this.reload) {
                    window.location.search = query;
                } else {
                    this.$emit('changePage', {page: page});
                }
            }
        },
        mounted: function () {
            $(window).bind("pageshow", function(event) {
                if (event.originalEvent.persisted) {
                    window.location.reload();
                }
            });
        }
    }
</script>
